export default __webpack_public_path__ + "static/media/Mark-6-Suit-10.aafa31f6.jpg";